<form 
    [fxLayout]="formConfig.fxLayout" 
    [fxLayoutAlign]="formConfig.fxLayoutAlign" 
    [fxLayoutGap]="formConfig.fxLayoutGap" 
    [formGroup]="form">
    <div 
        *ngFor="let field of formConfig.fields;" 
        [fxFlex.xs]="field.fxFlex.xs"
        [fxFlex.sm]="field.fxFlex.sm"
        [fxFlex.md]="field.fxFlex.md"
        [fxFlex.gt-md]="field.fxFlex.md">
        <ng-container dynamicField [field]="field" [group]="form">
            <div class="dynLabel">
                <span class="dynLabel__label" spanTitle fs_text bold>{{field.spanLabel}}</span>
                
                <mat-icon *ngIf="field.iconLabel" [svgIcon]=getIcon(field) class='dynamicFormInfoIcon' matPreffix (click)="iconClick(field)"></mat-icon>
                
                <mat-icon 
                    *ngIf="field.info"
                    class='dynamicFormInfoIcon info' 
                    (click)="show_popupInfo(field)"
                >info_outlined</mat-icon>
               
                 <!--   {{field.iconLabel}}--> 
              <!--  <mat-icon class="fs-4 file" matPreffix svgIcon="file"></mat-icon>
                <mat-icon class="fs-4" matPreffix color="accent">control_point</mat-icon>-->
            </div>
        </ng-container>
    </div>
</form>